//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProductTraceability from "@/Manager/10.Tms/ProductSnManager";
export default {
  props: {},
  data() {
    return {
      mydate: "",
      pageIndex: 0,
      detailinfor: 0,
      ItemList: []
    };
  },
  created() {
  },
  mounted() {
    this.onLoadListData();
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    onLoadListData() {
      this.$msg.showLoading("正在加载");
      var pageIndex = this.pageIndex;
      ProductTraceability.SalesVolumeList(pageIndex).then(res => {
        this.$msg.hideLoading();
        if (res.state == 1) {
          this.detailinfor = res.data.TotalCount;
            this.detailData = res.data;
            this.ItemList = res.data.List;
        }
      });
    },
    throttle(fn, wait) {
      var timer = null;
      return function() {
        var context = this;
        var args = arguments;
        if (!timer) {
          timer = setTimeout(function() {
            fn.apply(context, args);
            timer = null;
          }, wait);
        }
      };
    },

    //文档高度
    getDocumentTop() {
      var scrollTop = 0,
        bodyScrollTop = 0,
        documentScrollTop = 0;
      if (document.body) {
        bodyScrollTop = document.body.scrollTop;
      }
      if (document.documentElement) {
        documentScrollTop = document.documentElement.scrollTop;
      }
      scrollTop =
        bodyScrollTop - documentScrollTop > 0
          ? bodyScrollTop
          : documentScrollTop;
      return scrollTop;
    },

    //可视窗口高度
    getWindowHeight() {
      var windowHeight = 0;
      if (document.compatMode == "CSS1Compat") {
        windowHeight = document.documentElement.clientHeight;
      } else {
        windowHeight = document.body.clientHeight;
      }
      return windowHeight;
    },

    //滚动条滚动高度
    getScrollHeight() {
      var scrollHeight = 0,
        bodyScrollHeight = 0,
        documentScrollHeight = 0;
      if (document.body) {
        bodyScrollHeight = document.body.scrollHeight;
      }

      if (document.documentElement) {
        documentScrollHeight = document.documentElement.scrollHeight;
      }
      scrollHeight =
        bodyScrollHeight - documentScrollHeight > 0
          ? bodyScrollHeight
          : documentScrollHeight;
      return scrollHeight;
    },
    //滚动监听
    handleScroll() {
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (
        this.getScrollHeight() ==
        this.getWindowHeight() + this.getDocumentTop()
      ) {
        var newpageIndex = ++this.pageIndex;
        var bars = parseInt(this.detailinfor / 10);
        console.log(bars);
        if (newpageIndex >= bars) {
          this.$msg.info("全部加载完成");
          return;
        }
        {
          this.$msg.showLoading("加载下一页");
          ProductTraceability.SalesVolumeList(newpageIndex).then(
            res => {
              this.$msg.hideLoading();
              if (res.state == 1) {
                for (var obj of res.data.List) {
                  this.ItemList.push(obj);
                }
              }
            }
          );
        }
      }
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
